import styled from 'styled-components';

export const DetailsHeaderStyled = styled(`p`)`
	margin: 0;
	color: #77818e;
	font-weight: 400;
	font-size: 14px;
`;

export const DetailsTextStyled = styled(`p`)`
	margin: 0;
	font-weight: 400;
	font-size: 14px;
`;

export const DetailsContainerStyled = styled(`div`)`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 28px;
	margin-bottom: 32px;
	width: 100%;
`;

export const DetailsItemStyled = styled(`div`)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 33%;
`;

export const SeparatorStyled = styled(`div`)`
	width: 1px;
	height: 30px;
	background-color: #77818e;
`;
